<template>
  <div class="page page__has-bar">
    <div class="page__bd">
      <custom-layout class="weui-cells" :view-config="customViewConfig">
        <div class="weui-cell" slot="ta_rpname">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.ta_rpname || "研发阶段"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            {{ form.main.ta_rpname }}
          </div>
        </div>
        <div class="weui-cell" slot="ta_taskroute">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.ta_taskroute || "研发路径"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            {{ form.main.ta_taskroute }}
          </div>
        </div>
        <div class="weui-cell" slot="ta_pjcode">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.ta_pjcode || "项目单号"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            {{ form.main.ta_pjcode }}
          </div>
        </div>
        <div class="weui-cell" slot="pj_dename">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.pj_dename || "项目名称"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            {{ form.main.pj_dename }}
          </div>
        </div>
        <div class="weui-cell" slot="pj_emname">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.pj_emname || "项目负责人"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            {{ form.main.pj_emname }}
          </div>
        </div>
        <div class="weui-cell" slot="pj_emtel">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.pj_emtel || "联系电话"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            {{ form.main.pj_emtel }}
          </div>
        </div>
        <div class="weui-cell" slot="pj_begin_date">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.pj_begin_date || "开始时间"
            }}</label>
          </div>
          <div class="weui-cell__bd" v-format="'yyyy-MM-dd'">
            {{ form.main.pj_begin_date }}
          </div>
        </div>
        <div class="weui-cell" slot="pj_end_date">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.pj_end_date || "完成日期"
            }}</label>
          </div>
          <div class="weui-cell__bd" v-format="'yyyy-MM-dd'">
            {{ form.main.pj_end_date }}
          </div>
        </div>
        <div class="weui-cell" slot="ta_taskstatus">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.ta_taskstatus || "状态"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            {{ form.main.ta_taskstatus }}
          </div>
        </div>
        <div class="weui-cell" slot="ta_task">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.ta_task || "任务名称"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            {{ form.main.ta_task }}
          </div>
        </div>
        <div class="weui-cell" slot="ta_emname">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.ta_emname || "责任人"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            {{ form.main.ta_emname }}
          </div>
        </div>
        <div class="weui-cell" slot="ta_role">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.ta_role || "岗位"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            {{ form.main.ta_role }}
          </div>
        </div>
        <div class="weui-cell" slot="ta_planbegindate">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.ta_planbegindate || "计划开始日期"
            }}</label>
          </div>
          <div class="weui-cell__bd" v-format="'yyyy-MM-dd hh:mm'">
            {{ form.main.ta_planbegindate }}
          </div>
        </div>
        <div class="weui-cell" slot="ta_planenddate">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.ta_planenddate || "计划结束日期"
            }}</label>
          </div>
          <div class="weui-cell__bd" v-format="'yyyy-MM-dd hh:mm'">
            {{ form.main.ta_planenddate }}
          </div>
        </div>
        <div class="weui-cell" slot="ta_planworkhour">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.ta_planworkhour || "计划工时"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            {{ form.main.ta_planworkhour }}
          </div>
        </div>

        <div class="weui-cell" slot="ta_actbegindate">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.ta_actbegindate || "实际开始日期"
            }}</label>
          </div>
          <div class="weui-cell__bd" v-format="'yyyy-MM-dd hh:mm'">
            {{ form.main.ta_actbegindate }}
          </div>
        </div>
        <div class="weui-cell" slot="ta_actenddate">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.ta_actenddate || "实际结束日期"
            }}</label>
          </div>
          <div class="weui-cell__bd" v-format="'yyyy-MM-dd hh:mm'">
            {{ form.main.ta_actenddate }}
          </div>
        </div>
        <div class="weui-cell" slot="ta_actworkhour">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.ta_actworkhour || "实际工时"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            {{ form.main.ta_actworkhour }}
          </div>
        </div>
        <div class="weui-cell" slot="rd_taskreq">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.rd_taskreq || "任务要求"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            {{ form.main.rd_taskreq }}
          </div>
        </div>
        <requirement-check-box
          slot="ta_taskreq"
          label="已达成要求"
          title="选择已达成要求"
          :items="taskReqOptions"
          v-model="selectedRequirements"
          @select="onRequirementsSelect"
        />
      </custom-layout>

      <div class="weui-cells__group">
        <div class="weui-cells">
          <file-field v-model="form.main.ta_attach" />
        </div>
      </div>
    </div>

    <div class="footer-bar weui-dialog__ft">
      <a
        href="javascript:;"
        v-if="form.main.ta_taskstatus == '待启动'"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="startTask"
        >启动</a
      >
      <a
        href="javascript:;"
        v-if="form.main.ta_taskstatus == '已启动'"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="save"
        >保存</a
      >
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="$router.back()"
        >取消</a
      >
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import RequirementCheckBox from "@/components/field/RequirementCheckBox.vue";
import FileField from "@/components/field/FileField.vue";
import process from "@/mixins/process.js";

export default {
  components: {
    CustomLayout,
    FileField,
    RequirementCheckBox,
  },
  mixins: [process],
  data() {
    return {
      baseUrl: "/api/plm/projtask",
      codeField: "ta_code",
      statusField: "ta_statuscode",
      caller: "PlmProjTask",
      xtype: "plm-projtask-formpanel",
      form: {
        main: {
          pj_deid: null,
          pj_dename: null,
          pp_emname: null,
          rd_taskreq: null,
          ta_planbegindate: null,
          ta_planworkhour: null,
          ta_taskreq: null,
        },
      },
      selectedRequirements: [], // 选中的值数组
      taskReqOptions: [], // 任务要求选项数组
    };
  },
  watch: {
    // 监听 rd_taskreq 字符串变化，更新选项和选中值
    "form.main.rd_taskreq": {
      handler(newVal) {
        if (newVal) {
          // 将字符串转换为数组
          this.taskReqOptions = newVal.split(",");
        }
      },
      immediate: true,
    },
    "form.main.ta_taskreq": {
      handler(newVal) {
        if (newVal) {
          this.selectedRequirements = this.form.main.ta_taskreq
            ? this.form.main.ta_taskreq.split(",")
            : [];
        }
      },
      immediate: true,
    },
  },
  methods: {
    onRequirementsSelect(selected) {
      this.form.main.ta_taskreq = selected.join(",");
    },
    startTask() {
      let me = this,
        main = me.form.main,
        id = main.id;
      me.$loading({
        url: "/api/plm/projtask/startTask/" + id,
        method: "POST",
      }).then(function (res) {
        if (res.success) {
          me.$weui.toast("任务启动成功!");
          // 刷新页面以显示最新的数据
          setTimeout(() => {
            me.$router.go(0);
          }, 1000);
        } else {
          me.$weui.topTips(res.message, 2000);
        }
      });
    },
    /**
     * 保存
     */
    save() {
      var me = this,
        main = me.form.main;
      if (!main.ta_taskreq) {
        me.$weui.topTips("请选择已达成要求", 2000);
      } else {
        me.p_save();
      }
    },
    
  },
};
</script>
